export async function encryptPassword(password: string): Promise<string> {
  const encoder = new TextEncoder();

  const key = await crypto.subtle.importKey(
    "raw",
    encoder.encode(import.meta.env.RAM_SECRET_KEY),
    "AES-GCM",
    false,
    ["encrypt"]
  );

  const encryptedBuffer = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv: encoder.encode(import.meta.env.RAM_FIXED_IV) },
    key,
    encoder.encode(password)
  );

  return btoa(String.fromCharCode(...new Uint8Array(encryptedBuffer)));
}
